module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "my-product"
  }, [_c('tab-header', {
    attrs: {
      "tabList": _vm.productTabList,
      "tabName": _vm.tabName,
      "isSort": false,
      "isCount": false,
      "isSelf": _vm.isSelf
    },
    on: {
      "getTabName": _vm.getTabName
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "product-content"
  }, [(_vm.productList.length) ? _c('ul', {
    staticClass: "product-list"
  }, [_vm._l((_vm.productList), function(item, index) {
    return [_c('product', {
      key: index,
      attrs: {
        "productInfo": item,
        "isPersonCenter": true
      },
      on: {
        "handleToggleCollect": _vm.handleToggleCollect
      }
    })]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.productList.length && !_vm.isLoading),
      expression: "!productList.length && !isLoading"
    }],
    staticClass: "content-empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/personal_center/data-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]), _vm._v(" "), (_vm.isMoreLoading || _vm.productList.length) ? _c('div', {
    staticClass: "load-more"
  }, [(_vm.isMoreLoading) ? _c('img', {
    attrs: {
      "alt": "loadding",
      "src": require("../../images/common/loading_2_24x24.gif")
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.totalPage === _vm.curPage ? '没有更多内容了' : '显示更多'))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-340c6b93!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/my_product.vue
// module id = MRN1
// module chunks = 15